// Save / un-save a parish (Lookup Tool profile page). Progressive enhancement:
// the form posts normally with JS off; here we intercept the submit, POST it in
// the background (CSRF token + action handle travel in the FormData), and toggle
// the button's label and aria-pressed state from the JSON response.
const savedParishForm = document.querySelector("[data-saved-parish]");

if (savedParishForm) {
  const toggleButton = savedParishForm.querySelector("[data-saved-parish-toggle]");
  const toggleLabel = savedParishForm.querySelector("[data-saved-parish-label]");

  savedParishForm.addEventListener("submit", (e) => {
    e.preventDefault();
    toggleButton.disabled = true;

    fetch(savedParishForm.action, {
      method: "POST",
      body: new FormData(savedParishForm),
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then(({ saved }) => {
        toggleButton.setAttribute("aria-pressed", saved ? "true" : "false");
        toggleLabel.textContent = saved ? "Saved" : "Save this parish";
      })
      .catch(() => {
        // Background post failed — fall back to a full submit so the click isn't lost.
        savedParishForm.submit();
      })
      .finally(() => {
        toggleButton.disabled = false;
      });
  });
}
